import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/previsiones-sociales-exentas';

/**
 * GET Previsiones Sociales Exentas
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getPrevisionesSocialesExentas = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Prevision Social Exenta
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getPrevisionSocialExenta = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Prevision Social Exenta
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPrevisionSocialExenta = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Prevision Social Exenta
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPrevisionSocialExenta = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Prevision Social Exenta
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deletePrevisionSocialExenta = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
